var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('preview-security',{attrs:{"item":_vm.item,"action-type":_vm.actionType},on:{"success":function($event){return _vm.$emit('success', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }